import SeasonType from "./actionTypes"



// function that called as action
const getListPage = data => ({
  type: SeasonType.GET_SEASON_PAGES,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListPageSuccess = data => ({
  type: SeasonType.GET_SEASON_PAGES_SUCCESS,
  payload: data,
})

// function that called as action
const getDetail = (data, action) => ({
  type: SeasonType.GET_DETAIL_SEASON_BY_ID,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getDetailSuccess = data => ({
  type: SeasonType.GET_DETAIL_SEASON_BY_ID_SUCCESS,
  payload: data,
})

// function that called as action
const postData = (data, action) => ({
  type: SeasonType.POST_SEASON,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const postDataSuccess = data => ({
  type: SeasonType.POST_SEASON_SUCCESS,
  payload: data,
})

// function that called as action
const putData = (data, action) => {
  return {
    type: SeasonType.PUT_SEASON,
    payload: data,
    action
  }
}

// function to update state in reducer when fetching api is succeed or failed
const putDataSuccess = data => ({
  type: SeasonType.PUT_SEASON_SUCCESS,
  payload: data,
})


// function that called as action
const getList = data => ({
  type: SeasonType.GET_SEASON_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListSuccess = data => ({
  type: SeasonType.GET_SEASON_LIST_SUCCESS,
  payload: data,
})


const SeasonAction = {
  getListPage,
  getListPageSuccess,


  getDetail,
  getDetailSuccess,


  postData,
  postDataSuccess,

  putData,
  putDataSuccess,

  getList,
  getListSuccess,

}

export default SeasonAction





